import moment from 'moment'
import {
    MainMeansOfTransport,
} from 'app/enums/label.enums'
import {
    strToDate,
} from 'app/utils/date'

import useStyles from './EstimatedDeliveryDeparture.style'

const executionTime = {
    SEA: 48,
    AIR: 24,
}

type Props = {
    value: string,
    rowProps: {
        mainMeansOfTransport: MainMeansOfTransport,
        actualPickupFirstStep: string,
    }
}

const EstimatedDeliveryDeparture = ({
    value,
    rowProps,
}: Props) => {
    const {
        classes,
    } = useStyles()

    if (!rowProps?.actualPickupFirstStep) {
        return value ? (<div className={classes.grey}>value</div>) : null
    }
    const diff = moment().diff(moment(strToDate(rowProps?.actualPickupFirstStep), 'X'), 'hours')

    const color = diff > executionTime[rowProps?.mainMeansOfTransport]
        ? classes.red
        : classes.grey

    return (
        <div className={color}>{value}</div>
    )
}

export default EstimatedDeliveryDeparture
